import { type InputHTMLAttributes } from "react";

import { APP_COLORS } from "@styles/colors";
import { cn } from "@utils/tailwind.util";

interface DividerProps extends InputHTMLAttributes<HTMLInputElement> {
  height?: string;
  backgroundColor?: string;
  className?: string;
}

export function Divider({
  height = "1px",
  backgroundColor = `${APP_COLORS.stroke.primary}`,
  className = "",
}: DividerProps) {
  const dividerStyle = {
    background: `${backgroundColor}`,
  };

  return (
    <hr
      className={cn(`h-[${height}] w-full shadow-divider dark:shadow-dividerDark`, className)}
      style={dividerStyle}
    />
  );
}
